import React, { useMemo } from 'react';

import { Controller } from 'react-hook-form';

import { useProjectTreeStore } from 'store/projectContract.store';
import { useVersionStore } from 'store/version.store';

import { useQueryGetSegmentsList } from 'api/queries/getSegmentsList.query';

import { MyCustomSelect } from 'components/common';

export const SegmentSelect = ({ methods, name }) => {
    const { contract } = useProjectTreeStore();
    const { version } = useVersionStore();
    const { data } = useQueryGetSegmentsList({ metaDataId: version?.id, contractId: contract?.id });

    const options = useMemo<ISelectOption<number>[]>(
        () =>
            data
                ? data.map((item) => ({
                      label: item.name,
                      value: item.segmentId,
                  }))
                : [],
        [data],
    );

    const handleChange = (value: ISelectOption<number> | null) => {
        methods?.setValue(name, value ? value.value : null, { shouldDirty: true });
    };

    const handleValue = (value) => {
        if (!value) {
            return null;
        }

        return (
            data?.map((item) => ({ label: item.name, value: item.segmentId })).find((item) => item.value === value) ||
            null
        );
    };

    return (
        <Controller
            render={({ field }) => (
                <MyCustomSelect<ISelectOption<number>>
                    {...field}
                    options={options}
                    isClearable={true}
                    onChange={handleChange}
                    value={handleValue(field.value)}
                    placeholder={'Select segment or start typing its name...'}
                />
            )}
            name={name}
            control={methods?.control}
        />
    );
};
